import { Skeleton } from '../../components/ui/skeleton';

/** Skeleton mirroring a list/card layout — avoids a full-page spinner after entry. */
export const PortalSkeletonRows = ({ rows = 3, testId = 'portal-skeleton' }) => (
  <div className="portal-skeleton-rows" data-testid={testId} aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="portal-skeleton-row" key={i}>
        <Skeleton className="portal-skeleton-icon" />
        <div className="portal-skeleton-lines">
          <Skeleton className="portal-skeleton-line portal-skeleton-line-wide" />
          <Skeleton className="portal-skeleton-line portal-skeleton-line-narrow" />
        </div>
      </div>
    ))}
  </div>
);
